import { useNavigate } from 'react-router';
import styled from 'styled-components';

const icon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
</svg>
)

const StyledButton = styled.button`
  border: none;
  background-color: transparent;
  height: 32px;
  border-radius: ${({ theme }) => theme.border.radius.sm};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.light};
  }
`

export const BackButton = () => {
  const navigate = useNavigate()

  return (
    <StyledButton type="button" onClick={() => navigate(-1)}>
      {icon}
    </StyledButton>
  )
}